import React from "react";
import Navbar from "../Navbar/Navbar";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Software Development",
    description:
      "Custom web, mobile, and multi-platform applications engineered to solve your specific business challenges. From SaaS products to internal tools, we build software that ships and scales.",
    details: [
      "Web applications",
      "Mobile apps (Android & iOS)",
      "POS system integrations",
      "SaaS product development",
      "API design & architecture",
    ],
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
      </svg>
    ),
  },
  {
    title: "Business Consulting",
    description:
      "Strategic guidance to help you navigate digital transformation. We work with you to identify the right technology decisions and operational improvements for your business.",
    details: [
      "Technology strategy & roadmapping",
      "Digital transformation planning",
      "Process optimisation",
      "Vendor & tool evaluation",
      "Growth infrastructure planning",
    ],
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605" />
      </svg>
    ),
  },
  {
    title: "Digital Marketing",
    description:
      "Data-driven marketing strategies that connect your product to the right audience. We help you build a presence that converts visitors into loyal customers.",
    details: [
      "Search engine optimisation (SEO)",
      "Content marketing strategy",
      "Social media management",
      "Performance & analytics",
      "Brand positioning",
    ],
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46" />
      </svg>
    ),
  },
  {
    title: "Brand Design",
    description:
      "Visual identity systems that communicate who you are. We create cohesive design languages that work across every touchpoint, from your logo to your product interface.",
    details: [
      "Visual identity & logo design",
      "UI/UX design",
      "Design systems",
      "Print & packaging",
      "Presentation design",
    ],
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
      </svg>
    ),
  },
];

export default function HeroServices() {
  return (
    <>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 bg-white overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-50 rounded-full blur-3xl opacity-60" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-16">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-full mb-8 border border-blue-100">
              <div className="w-1.5 h-1.5 rounded-full bg-[#0186ef]" />
              <span className="text-xs font-semibold text-[#0186ef] uppercase tracking-wider">
                Services
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-[1.1] tracking-tight mb-6">
              End-to-end digital{" "}
              <span className="text-[#0186ef]">solutions</span>
            </h1>

            <p className="text-lg text-gray-500 leading-relaxed max-w-2xl">
              From concept to deployment, we partner with businesses to build,
              market, and scale digital products. Here's how we can help.
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-24 lg:py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="space-y-8">
            {services.map((service, i) => (
              <div
                key={i}
                className="bg-white rounded-3xl border border-gray-100 p-8 lg:p-12 hover:shadow-xl transition-all duration-500"
              >
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
                  <div className="lg:col-span-7">
                    <div className="flex items-start gap-5">
                      <div className="w-14 h-14 rounded-2xl bg-[#0186ef]/10 text-[#0186ef] flex items-center justify-center flex-shrink-0">
                        {service.icon}
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">
                          {service.title}
                        </h3>
                        <p className="text-gray-500 leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="lg:col-span-5">
                    <div className="bg-gray-50 rounded-2xl p-6">
                      <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
                        What's included
                      </div>
                      <ul className="space-y-3">
                        {service.details.map((detail, j) => (
                          <li key={j} className="flex items-start gap-3 text-sm text-gray-600">
                            <svg className="w-4 h-4 text-[#0186ef] mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              How we work
            </h2>
            <p className="text-lg text-gray-500 max-w-xl mx-auto">
              A straightforward process designed to keep projects on track and
              deliver real results.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: "01",
                title: "Discover",
                desc: "We listen. Understanding your business, goals, and constraints is where every great project starts.",
              },
              {
                step: "02",
                title: "Plan",
                desc: "We map out the technical approach, timeline, and milestones, so everyone's aligned from day one.",
              },
              {
                step: "03",
                title: "Build",
                desc: "We ship iteratively, keeping you involved at every stage with regular demos and check-ins.",
              },
              {
                step: "04",
                title: "Launch & Support",
                desc: "We don't disappear after launch. We help you deploy, monitor, and refine your product over time.",
              },
            ].map((phase) => (
              <div key={phase.step} className="relative p-6">
                <div className="text-5xl font-bold text-gray-100 mb-4">
                  {phase.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {phase.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {phase.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 lg:py-32 bg-gray-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-16 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Ready to get started?
          </h2>
          <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto">
            Tell us about your project and we'll figure out the best way to help.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex px-8 py-4 text-sm font-semibold text-gray-900 bg-white rounded-full hover:bg-gray-100 transition-all duration-300 hover:shadow-lg"
            >
              Start a Conversation
            </Link>
            <Link
              to="/work"
              className="inline-flex px-8 py-4 text-sm font-semibold text-white border border-white/20 rounded-full hover:bg-white/10 transition-all duration-300"
            >
              View Our Work
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
